import {
	ChangeDetectionStrategy,
	Component,
	model,
	signal,
} from '@angular/core';
import { IconsModule } from 'src/app/ui/icons/icons.module';

export enum ESigningViewTab {
	ESIGNING = 'e-signing',
	DOCUMENTS = 'documents',
}

interface Tab {
	value: ESigningViewTab;
	label: string;
	intercomAttr?: string;
	route: string;
	icon?: string;
}

@Component({
	selector: 'app-e-signing-view-tab',
	imports: [IconsModule],
	templateUrl: './e-signing-view-tab.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ESigningViewTabComponent {
	public selectedTab_ = model<ESigningViewTab>();
	public tabs_ = signal<Tab[]>([
		{
			value: ESigningViewTab.ESIGNING,
			label: 'Signing Fields',
			intercomAttr: 'e-signing-tab',
			route: 'e-signing',
			icon: 'writing',
		},
		{
			value: ESigningViewTab.DOCUMENTS,
			label: 'Documents',
			intercomAttr: 'documents-tab',
			route: 'documents',
			icon: 'edit',
		},
	]);
}
